import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHitMapSearchParams {
    regionName: string;
    selectionName: string;
    action: "on" | "off";
    eventName?: string;
}

export function hitMapCheckboxToggle(params: IHitMapSearchParams) {
    const {regionName, selectionName, action, eventName} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: "checkbox",
        event_category: regionName,
        event_category2: selectionName,
        event_label: action
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHitMapSearchParams {
    regionName: string;
    selectionName: string;
    action: "on" | "off";
    eventName?: string;
}

export function hitMapCheckboxToggle(params: IHitMapSearchParams) {
    const {regionName, selectionName, action, eventName} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: "checkbox",
        event_category: regionName,
        event_category2: selectionName,
        event_label: action
    });
}
